<accordion [isAnimated]="true">
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-user'></i> Información de la Empresa
    </span>

    <form class="form-horizontal" [formGroup]="companyInformationForm">
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre Legal</b>
          <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="legalName"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="legalName">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-8">
          <label class="col-form-label"><b>RTN</b>
            <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="fiscalId"></span>
          </label>
          <input type="text" class="form-control" formControlName="fiscalId">
        </div>
        <div class="form-group col-md-4">
          <label class="col-form-label"><b>Tipo de Identificación</b>
            <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="fiscalIdName"></span>
          </label>
          <input type="text" class="form-control" formControlName="fiscalIdName">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nacionalidad</b>
          <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="nationality"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="nationality" [items]="nationalities" bindLabel="name" bindValue="code">
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Giro o Activdad Economica</b>
          <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="economicActivity" ></span>
      </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="economicActivity" [items]="economicActivities" bindLabel="description" bindValue="key" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre Comercial</b>
          <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="commercialName"></span>
      </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="commercialName" [ngClass]="companyInformationForm.controls.commercialName.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Fecha de Inicio de Operaciones</b>
          <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="operationDate"></span>
      </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input bsDatepicker class="form-control" formControlName="operationDate" [ngClass]="companyInformationForm.controls.operationDate.errors ? 'is-invalid' : 'is-valid'" [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tamaño de la Empresa</b>
          <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="companySize"></span>
      </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="companySize" [items]="companySize" bindLabel="value" bindValue="key" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Número de Empleados</b>
          <span appRequiredAsterisk [formGroup]="companyInformationForm" controlName="amountEmployees"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="number" class="form-control" formControlName="amountEmployees" [ngClass]="companyInformationForm.controls.amountEmployees.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        </div>
      </div>
      
    </form>
  </accordion-group>


</accordion>
